import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";

import "./Lgname.scss";
import Progress from "../../../components/Progress/Progress";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";
import { StepPreFooter } from "../../../components/Footer/StepPreFooter";

import { Controller, useForm } from "react-hook-form";
import { updateTemporaryContact } from "../../../redux/contactRedux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import {
  Box,
  FormControl,
  MenuItem,
  FormHelperText,
  TextField,
  Select,
  CircularProgress,
  InputAdornment
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";


import { loanReasonOptions } from "../../../utils/options";
import { zipCodeRequest } from "../../../requestMethods";

import step2Icon from "../../../assets/images/step-icon/step2-icon.png";

import {
  MenuProps,
  labelCustom,
  selectCustom,
  menuItemCustom,
  textFieldCustom,
  textInputStyles
} from "./style";

import { trimWhiteSpaceObjValue } from "../../../utils/functions";
import { StepBtn } from "../../../components/Button/StepBtn/StepBtn";
import { amountOptions } from "../../../utils/options";
import { nextStepDelayTime } from "../../../utils/const";

const Lgname = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = window.innerWidth < 768;
  const windowWidth = window.innerWidth;

  const [loadingButton, setLoadingButton] = useState(false);

  const contactRedux = useSelector((state) => state?.contact?.contact);
  const temporaryContact = useSelector((state) => state?.contact?.temporary);

  const [firstName, setFirstName] = useState(contactRedux?.firstName ?? "");
  const [lastName, setLastName] = useState(contactRedux?.lastName ?? "");

  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [amount, setAmount] = useState(
    temporaryContact?.loanAmount ?? contactRedux?.amount ?? amountOptions[3]?.value
  );
  
  const [loanReason, setLoanReason] = useState(
    temporaryContact?.loanReason ?? contactRedux?.loanReason ?? loanReasonOptions[3].value
  );
  
  const [zipCode, setZipCode] = useState(
    temporaryContact?.zip ?? contactRedux?.zip ?? contactRedux?.zipCode ?? ""
  );
  const [city, setCity] = useState(temporaryContact?.city ?? "");
  const [state, setState] = useState(temporaryContact?.state ?? "");
  const [loadingZip, setLoadingZip] = useState(false);

  const jornayaRef = useRef(null);
  const [jornayaLeadId, setJornayaLeadId] = useState("");

  const loanReasonFromURL = sessionStorage.getItem("loanReasonFromURL");



  useEffect(() => {
    isMobile && window.scrollTo(0, 66);
  }, [isMobile]);

  // jornaya lead id
  useEffect(() => {
    const checkValue = () => {
      const value = jornayaRef.current?.value;
      if (value) {
        setJornayaLeadId(value);
      } else {
        setTimeout(checkValue, 1000);
      }
    };
    checkValue();
    return () => {
    };
  }, []);

  // Function to check zip code
  const checkZipCode = async (zip) => {
    if (loadingZip) return null;
    setLoadingZip(true);

    try {
      const res = await zipCodeRequest.get("", {
        params: { lead_id: '123', zip: zip }
      });
      const result = res?.data?.data;
      if (result?.city) {
        setState(result.state);
        setCity(result.city);
        return { state: result.state, city: result.city, lat: result?.lat, lon: result?.long };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    } finally {
      setLoadingZip(false);
    }
  };

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors }
  } = useForm();

  const handleFormSubmit = async (data) => {
    if (loadingButton) { return false }
    setLoadingButton(true);
    try {
      trimWhiteSpaceObjValue(data);

      // Validate zip code if provided
      if (data.zipCode) {
        const zipResult = await checkZipCode(data.zipCode);
        if (!zipResult) {
          setError("zipCode", {
            type: "manual",
            message: "Invalid zip code",
          });
          setLoadingButton(false);
          return;
        }
        // Add city and state to data
        data.city = zipResult.city;
        data.state = zipResult.state;
        data.lat = zipResult.lat;
        data.lon = zipResult.lon;
        data.zip = data.zipCode;
      }

      // Add jornaya lead id if available
      if (jornayaLeadId) {
        data.jornayaLeadId = jornayaLeadId;
      }

      dispatch(updateTemporaryContact(data));

      setTimeout(() => {
        navigate("/email");
      }, nextStepDelayTime);

    } catch (error) {
      console.error("Error updating contact:", error);
      setLoadingButton(false);
    } finally {
      setLoadingButton(false);
    }
  };
  // const onSubmit = handleSubmit(handleFormSubmit);

  return (
    <Box className="lgname">
      <Navbar />
      <ScrollToTop />
      <Box
        sx={{
          width: "100%",
          maxWidth: "700px",
          margin: "20px auto 0"
        }}
      >
        <div className="step-main">
          <form className="step-form" onSubmit={handleSubmit(handleFormSubmit)}>
            <Box
              sx={{
                width: "100%",

                margin: "10px auto 30px",
                padding: isMobile && "0 15px"
              }}
            >
              <Progress step={2} />
            </Box>

            <Box sx={{ textAlign: "center", marginBottom: "11px" }}>
              <img
                style={{
                  maxWidth: isMobile && "42px"
                }}
                src={step2Icon}
                alt=""
              />
            </Box>
            <h2 className="title">Your Legal Name</h2>
            <div className="form-control">
              {/* Loan Amount */}
              <Controller
                name="amount"
                defaultValue={amount}
                control={control}
                rules={{ required: "Loan amount is required!" }}
                render={({ field }) => (
                  <FormControl
                    fullWidth
                    error={!!errors?.amount}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      marginBottom: isMobile ? "7px" : "15px"
                    }}
                  >
                    <FormHelperText sx={labelCustom}>
                      Loan Amount ($100 - $5,000)
                    </FormHelperText>
                    <Select
                      {...field}
                      onChange={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        setAmount(value);
                      }}
                      value={amount}
                      displayEmpty
                      MenuProps={{
                        ...MenuProps,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center"
                        }
                      }}
                      sx={selectCustom}
                      onClose={() => {
                        setIsSelectOpen(false);
                      }}
                      onOpen={() => {
                        setIsSelectOpen(true);
                      }}
                      className={isSelectOpen ? "show" : ""}
                    >
                      {amountOptions.map((option, index) => (
                        <MenuItem
                          key={index}
                          value={option.value}
                          sx={menuItemCustom}
                          size="small"
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {errors?.amount && errors?.amount.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />

              {/* Reason for loan */}
              <Controller
                name="loanReason"
                defaultValue={loanReason}
                control={control}
                rules={{ required: "Loan reason is required!" }}
                render={({ field }) => (
                  <FormControl
                    fullWidth
                    error={!!errors?.loanReason}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      marginBottom: isMobile ? "7px" : "15px"
                    }}
                  >
                    <FormHelperText sx={labelCustom}>
                      Reason for loan
                    </FormHelperText>
                    <Select
                      {...field}
                      onChange={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        setLoanReason(value);
                      }}
                      value={loanReason}
                      displayEmpty
                      MenuProps={MenuProps}
                      sx={selectCustom}
                      onClose={() => {
                        setIsSelectOpen(false);
                      }}
                      onOpen={() => {
                        setIsSelectOpen(true);
                      }}
                      className={isSelectOpen ? "show" : ""}
                    >
                      {loanReasonOptions.map((option, index) => (
                        <MenuItem
                          key={index}
                          value={option.value}
                          sx={menuItemCustom}
                          size="small"
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {errors?.loanReason && errors?.loanReason.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />

              {/* Zip Code */}
              <FormHelperText sx={labelCustom}>Your Zip Code</FormHelperText>
              <Controller
                name="zipCode"
                control={control}
                defaultValue={zipCode}
                rules={{
                  required: "Zip code is required!",
                  minLength: {
                    value: 5,
                    message: "Zip code must be 5 characters long!"
                  }
                }}
                render={({ field: { ref, ...field } }) => (
                  <TextField
                    {...field}
                    inputRef={(input) => {
                      input?.addEventListener("focus", () => {
                        input?.setAttribute("inputmode", "numeric");
                      });
                      ref(input);
                    }}
                    id="zipCode"
                    sx={{ ...textFieldCustom, marginBottom: "7px" }}
                    variant="outlined"
                    fullWidth
                    type="text"
                    error={!!errors?.zipCode}
                    label={zipCode ? " " : "e.g. 90011"}
                    helperText={errors?.zipCode && errors?.zipCode?.message}
                    inputProps={{
                      maxLength: 5
                    }}
                    InputLabelProps={{
                      shrink: false,
                      style: { ...textInputStyles, color: "#B7B7B7" }
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      field.onChange(value);
                      setZipCode(value);
                      setState(null);
                      setCity(null);
                    }}
                    value={zipCode}
                    size={isMobile ? "small" : "medium"}
                    InputProps={{
                      endAdornment: loadingZip && (
                        <InputAdornment position="end">
                          <CircularProgress
                            size={windowWidth > 768 ? 20 : 15}
                            color="inherit"
                          />
                        </InputAdornment>
                      )
                    }}
                  />
                )}
              />
              {city && state && (
                <div className="box-state" style={{ marginBottom: "15px" }}>
                  <LocationOnIcon className="address-icon" sx={{ width: 20 }} />
                  <p className="state">
                    {city}, {state}
                  </p>
                </div>
              )}

              {/* loanAmount - old code for URL parameter */}
              {loanReasonFromURL && false && (
                <Controller
                  name="amount"
                  defaultValue={amount}
                  control={control}
                  rules={{ required: "Loan amount is required!" }}
                  render={({ field }) => (
                    <FormControl
                      fullWidth
                      error={!!errors?.amount}
                      size={isMobile ? "small" : "medium"}
                      sx={{
                        marginBottom: isMobile ? "7px" : "15px"
                      }}
                    >
                      <FormHelperText sx={labelCustom}>
                        Loan Amount ($100 - $5,000)
                      </FormHelperText>
                      <Select
                        {...field}
                        onChange={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          setAmount(value);
                        }}
                        value={amount}
                        displayEmpty
                        MenuProps={{
                          ...MenuProps,
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center"
                          }
                        }}
                        sx={selectCustom}
                        onClose={() => {
                          setIsSelectOpen(false);
                        }}
                        onOpen={() => {
                          setIsSelectOpen(true);
                        }}
                        className={isSelectOpen ? "show" : ""}
                      >
                        {amountOptions.map((option, index) => (
                          <MenuItem
                            key={index}
                            value={option.value}
                            sx={menuItemCustom}
                            size="small"
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>
                        {errors?.amount && errors?.amount.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              )}
              {/* firstName */}
              <FormHelperText sx={labelCustom}>First name</FormHelperText>
              <Controller
                name="firstName"
                control={control}
                defaultValue={firstName}
                rules={{
                  required: "FirstName is required!"
                }}
                render={({ field: { ref, ...field } }) => (
                  <TextField
                    {...field}
                    inputRef={ref}
                    id="firstName"
                    sx={{ ...textFieldCustom, marginBottom: "7px" }}
                    variant="outlined"
                    fullWidth
                    type="text"
                    error={!!errors?.firstName}
                    label={firstName ? " " : "e.g. John"}
                    helperText={errors?.firstName && errors?.firstName?.message}
                    InputLabelProps={{
                      shrink: false,
                      style: { ...textInputStyles, color: "#B7B7B7" }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      setFirstName(value);
                    }}
                    value={firstName}
                    size={isMobile ? "small" : "medium"}
                  />
                )}
              />
              {/* lastName */}
              <FormHelperText sx={labelCustom}>Last name</FormHelperText>
              <Controller
                name="lastName"
                control={control}
                defaultValue={lastName}
                rules={{
                  required: "lastName is required!"
                }}
                render={({ field: { ref, ...field } }) => (
                  <TextField
                    {...field}
                    inputRef={ref}
                    id="lastName"
                    sx={{ ...textFieldCustom, marginBottom: "20px" }}
                    variant="outlined"
                    fullWidth
                    type="text"
                    error={!!errors?.lastName}
                    label={lastName ? " " : "e.g. Smith"}
                    helperText={errors?.lastName && errors?.lastName?.message}
                    InputLabelProps={{
                      shrink: false,
                      style: { ...textInputStyles, color: "#B7B7B7" }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      setLastName(value);
                    }}
                    value={lastName}
                    size={isMobile ? "small" : "medium"}
                  />
                )}
              />
              
              {/* jornaya */}
              <input
                ref={jornayaRef}
                id="leadid_token"
                name="universal_leadid"
                type="hidden"
                value=""
              />
              
              <Box
                sx={{
                  maxWidth: "474px",
                  margin: "0 auto"
                }}
              >
                <StepBtn
                  prevLink="/"
                  onSubmit={handleSubmit(handleFormSubmit)}
                  loading={loadingButton}
                />
              </Box>
            </div>
          </form>
          <StepPreFooter />
        </div>
      </Box>
      {/* <Footer desc={false} /> */}
    </Box>
  );
};

export default Lgname;
